import {
  GetShowTranslationModal,
  GetShowDocumentPopup,
  GetShowPreviewDocument,
  GetCurrentDocumentsDialog,
  GetCreateCollectionPopup,
  GetAddToCollectionPopup,
  GetGlossaryModal,
  GetWarningPopup,
  GetShowFilters,
  GetShowFiles,
  GetSelectedExternalIdForTranslate,
  GetReferenceNameForTranslate,
  GetSharedLinkCollection,
  GetLayoutsListOpened,
  GetMediaPanelOpened,
  GetShowPreviewAuthorDocument,
  GetReferencesListOpened,
} from '~/constants/getters';
import {
  ShowTranslationModal,
  HideTranslationModal,
  ShowPreviewDocument,
  HidePreviewDocument,
  SetGlossaryModal,
  SetShowAddToCollectionPopup,
  SetWarningPopup,
  SetShowFilters,
  SetShowFiles,
  SetSharedLinkCollectionPopup,
  SetMediaPanelOpened,
  ShowPreviewAuthorDocument,
  HidePreviewAuthorDocument,
} from '~/constants/actions';
import { computed } from 'vue';
import { useStore } from 'vuex';
import {
  SetCreateCollectionPopup,
  SetCurrentDocumentsDialog,
  SetLayoutsListOpened,
  SetReferencesListOpened,
} from '~/constants/mutations';
import { CURRENT_DIALOG } from '~/constants/conversationModels';
import { GetTranslationCallback, GetTranslationType } from '~/constants/getters';

export default () => {
  const store = useStore();

  const translationModalState = computed(() => store.getters[`modalStore/${GetShowTranslationModal}`]);

  const selectedExternalIdForTranslate = computed(
    () => store.getters[`modalStore/${GetSelectedExternalIdForTranslate}`],
  );
  const translationType = computed(() => store.getters[`modalStore/${GetTranslationType}`]);

  const translationCallback = computed(() => store.getters[`modalStore/${GetTranslationCallback}`]);

  const referenceNameForTranslate = computed(() => store.getters[`modalStore/${GetReferenceNameForTranslate}`]);

  const currentDocumentsDialog = computed(() => store.getters[`modalStore/${GetCurrentDocumentsDialog}`]);

  const documentPopupState = computed(() => store.getters[`modalStore/${GetShowDocumentPopup}`]);

  const addToCollectionPopupState = computed(() => store.getters[`modalStore/${GetAddToCollectionPopup}`]);

  const sharedLinkCollectionState = computed(() => store.getters[`modalStore/${GetSharedLinkCollection}`]);

  const previewDocumentState = computed(() => store.getters[`modalStore/${GetShowPreviewDocument}`]);

  const previewAuthorDocument = computed(() => store.getters[`modalStore/${GetShowPreviewAuthorDocument}`]);

  const createCollectionPopupState = computed(() => store.getters[`modalStore/${GetCreateCollectionPopup}`]);

  const glossaryModalState = computed(() => store.getters[`modalStore/${GetGlossaryModal}`]);

  const filesModalState = computed(() => store.getters[`modalStore/${GetShowFiles}`]);

  const warningPopupState = computed(() => store.getters[`modalStore/${GetWarningPopup}`]);

  const showFilters = computed(() => store.getters[`modalStore/${GetShowFilters}`]);

  const layoutsListOpened = computed(() => store.getters[`modalStore/${GetLayoutsListOpened}`]);

  const referencesListOpened = computed(() => store.getters[`modalStore/${GetReferencesListOpened}`]);

  const mediaPanelOpened = computed(() => store.getters[`modalStore/${GetMediaPanelOpened}`]);

  const setLayoutsListOpened = (data) => store.dispatch(`modalStore/${SetLayoutsListOpened}`, data);
  const setReferencesListOpened = (data) => store.dispatch(`modalStore/${SetReferencesListOpened}`, data);

  const setShowFilters = (data) => store.dispatch(`modalStore/${SetShowFilters}`, data);

  const setShowFiles = (data) => store.dispatch(`modalStore/${SetShowFiles}`, data);

  const setWarningPopup = (data) => store.dispatch(`modalStore/${SetWarningPopup}`, data);

  const setMediaPanelOpened = (data) => store.dispatch(`modalStore/${SetMediaPanelOpened}`, data);

  const setCurrentDocumentsDialog = (data) => {
    if (data === currentDocumentsDialog.value && data !== CURRENT_DIALOG.document_panel) {
      store.dispatch(`modalStore/${SetCurrentDocumentsDialog}`, null);
    } else {
      store.dispatch(`modalStore/${SetCurrentDocumentsDialog}`, data);
    }
  };

  const setCreateCollectionPopup = (data) => store.dispatch(`modalStore/${SetCreateCollectionPopup}`, data);
  const setGlossaryModal = (data) => store.dispatch(`modalStore/${SetGlossaryModal}`, data);
  const setAddToCollectionPopup = (data) => store.dispatch(`modalStore/${SetShowAddToCollectionPopup}`, data);
  const setSharedLinkCollectionPopup = (data) => store.dispatch(`modalStore/${SetSharedLinkCollectionPopup}`, data);

  const showTranslationModal = (referenceId, referenceName, type = '', callback = () => { }) => {
    store.dispatch(`modalStore/${ShowTranslationModal}`, { referenceId, referenceName, callback, type });
  };
  const hideTranslationModal = () => {
    store.dispatch(`modalStore/${HideTranslationModal}`);
  };

  const showPreviewDocument = (startPage) => {
    store.dispatch(`modalStore/${ShowPreviewDocument}`, startPage);
  };
  const hidePreviewDocument = () => {
    store.dispatch(`modalStore/${HidePreviewDocument}`);
  };
  const showPreviewAuthorDocument = () => {
    store.dispatch(`modalStore/${ShowPreviewAuthorDocument}`);
  };
  const hidePreviewAuthorDocument = () => {
    store.dispatch(`modalStore/${HidePreviewAuthorDocument}`);
  };

  return {
    addToCollectionPopupState,
    createCollectionPopupState,
    currentDocumentsDialog,
    documentPopupState,
    filesModalState,
    glossaryModalState,
    sharedLinkCollectionState,
    translationModalState,
    hidePreviewDocument,
    hideTranslationModal,
    previewDocumentState,
    referenceNameForTranslate,
    translationType,
    selectedExternalIdForTranslate,
    translationCallback,
    setAddToCollectionPopup,
    setCurrentDocumentsDialog,
    setCreateCollectionPopup,
    setGlossaryModal,
    setShowFilters,
    setSharedLinkCollectionPopup,
    setShowFiles,
    setWarningPopup,
    showFilters,
    showTranslationModal,
    showPreviewDocument,
    warningPopupState,
    layoutsListOpened,
    setLayoutsListOpened,
    setMediaPanelOpened,
    mediaPanelOpened,
    previewAuthorDocument,
    showPreviewAuthorDocument,
    hidePreviewAuthorDocument,
    referencesListOpened,
    setReferencesListOpened,
  };
};
